import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { setAppCheckTokenProvider } from "@praesto/ai-client";
import "./globals.css";
import { i18n } from "./lib/i18n";
import { getAppCheckToken } from "./lib/auth-actions";
import { App } from "./App";

// The assistant client (built by the procedure module) sends this App Check
// token on every /api/ai call (C-16).
setAppCheckTokenProvider(getAppCheckToken);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
